import React from 'react';

interface FormSelectOption {
  value: string;
  label: string;
}

interface FormSelectProps {
  id: string;
  label: string;
  options: FormSelectOption[];
  error?: string;
  value: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
}

export function FormSelect({
  id,
  label,
  options,
  error,
  value,
  onChange,
  onBlur,
}: FormSelectProps) {
  return (
    <div>
      <label htmlFor={id} className="mb-2 block text-[14px] font-normal leading-[170%] text-[#3B3B3B]">
        {label}
      </label>
      <div className="relative">
        <select
          id={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onBlur={onBlur}
          style={{
            borderWidth: '1.5px',
            borderStyle: 'solid',
            borderColor: error ? '#EF4444' : '#E5E7EB',
            padding: '12px 16px',
            appearance: 'none',
          }}
          className={`w-full rounded-lg bg-white text-[16px] leading-[170%] text-[#3B3B3B] focus:outline-none focus:ring-2 focus:ring-[#7CF1C7] focus:border-transparent`}
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
        {/* Custom dropdown arrow */}
        <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
          <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1.5L6 6.5L11 1.5" stroke="#3B3B3B" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
}
